import useGetUserProfilePaths from './useGetUserProfilePaths'

export default useGetUserProfilePaths
